<template>
    <div class="plan-box">
        <el-row class="plan-box-bg">
            <el-row class="plan-box-ping plan-box-common">
                <h3>
                    <span>什么是</span>综合评价
                </h3>
                <div class="plan-box-you-title">WHAT IS COMPREHENSIVE EVALUATION</div>
                <p>
                    综合评价招生是高考改革逐步推动后兴起的新招生模式。也是为了改变“高考唯分数论”这一固定录取模式而新兴的一种特殊类型的招生方式，该类招生最大的特点是基于高考成绩、高校综合测试成绩和高中学业水平测试成绩，按照一定比例计算形成考生综合总分，最后按照综合总分择优录取。这样就能大幅度降低高考分数的占比，增加低分上名校的机会。
                </p>
            </el-row>
            <el-row class="plan-box-you plan-box-common">
                <h3>申报优势</h3>
                <div class="plan-box-you-title">DECLARATION ADVANTAGES</div>
                <el-row class="plan-box-you-infor">
                    <img src="../../assets/images/plan-people.png" class="plan-box-you-img">
                    <el-row class="plan-box-you-list">
                        <el-row v-for="(item,index) in youList" :key="index">
                            <el-col :span="2">
                                <img :src="item.src">
                            </el-col>
                            <el-col :span="22">
                                <h4>{{item.title}}</h4>
                                <p>{{item.desc}}</p>
                            </el-col>
                        </el-row>
                    </el-row>
                </el-row>
            </el-row>
        </el-row>
        <el-row class="plan-box-liu plan-box-common plan-box-common1">
            <h3><span>申报</span>流程</h3>
            <div class="plan-box-you-title">DECLARATION PROCESS</div>
            <el-row class="plan-box-liu-list">
                <el-row v-for="(item,index) in tipsList" :key="index">
                    <el-col class="plan-box-liu-center" :span="12">
                    </el-col>
                    <el-col class="plan-box-liu-left" :span="12" :class="index%2 == 0?'plan-box-liu-left-float':''">
                        <el-col class="plan-box-liu-month" :span="1">
                            <div class="plan-box-liu-line1" v-if="index < tipsList.length-1"></div>
                            <div class="plan-box-liu-circle1">
                                <span>{{item.month}}</span>月
                            </div>
                        </el-col>
                        <el-col class="plan-box-liu-common" :span="23" :class="index == tipsList.length-1?'plan-box-liu-item':index == 1?'plan-box-liu-item1':index == 3?'plan-box-liu-item2':''">
                            {{item.desc}}
                        </el-col>
                    </el-col>
                </el-row>
            </el-row>
            <p>
                <span>!</span>
                以上为大概申报时间，具体时间各院校公布时间点为准
            </p>
        </el-row>
        <el-row class="plan-box-nan plan-box-common plan-box-common1">
            <h3><span>申报</span>难点</h3>
            <div class="plan-box-you-title">DIFFICULTIES IN APPLICATION</div>
            <h4>
                为什么要<span>选择专业机构</span>进行综合评价申请？
            </h4>
            <img src="../../assets/images/plan-nan.png">
            <el-row class="plan-box-nan-item" style="margin-top: 48px">
                院校梯度需合理搭配
            </el-row>
            <el-row class="plan-box-nan-list">
                <el-col class="plan-box-nan-item" style="margin-right: 114px">
                    准备材料繁多复杂
                </el-col>
                <el-col class="plan-box-nan-item" style="margin-left: 114px">
                    细节问题较多容易错失机会
                </el-col>
            </el-row>
        </el-row>
        <el-row class="plan-box-step plan-box-common plan-box-common1">
            <h3><span>服务</span>流程</h3>
            <div class="plan-box-you-title">SERVICE DIFFICULTIES</div>
            <el-row class="plan-box-step-list">
                <el-col class="plan-box-step-item" v-for="(item,index) in stepList" :key="index" :class="index%2!=0?'plan-box-step-item-diff':''">
                    <div>
                        <h5>{{item.title}}</h5>
                        <div class="plan-box-step-circle">{{item.count}}</div>
                    </div>
                    <img src="../../assets/images/step-icon2.png" v-if="index%2!=0 && index != stepList.length-1">
                    <img src="../../assets/images/step-icon1.png" v-else-if="index%2==0 && index != stepList.length-1">
                </el-col>
            </el-row>
        </el-row>
        <el-row class="plan-box-service plan-box-common plan-box-common1">
            <h3 style="color:#fff">服务优势</h3>
            <div class="plan-box-you-title" style="color: rgba(255,255,255,0.23);">SERVICE ADVANTAGE</div>
            <el-row class="plan-box-service-list" type="flex" justify="space-between">
                <el-col v-for="(item,index) in serviceList" :key="index">
                    <img :src="item.src">
                    <h4>{{item.title}}</h4>
                    <div>{{item.desc}}</div>
                </el-col>
            </el-row>
        </el-row>
        <el-row class="plan-box-infor plan-box-order">
            <img src="../../assets/images/channel-order.png" alt="">
            <div>
                <span class="plan-box-order-title">预约专家 免费咨询</span>
                <span class="plan-box-order-desc">留下联系方式，立即与专家一对一</span>
            </div>
            <el-row>
                <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
                    <el-form-item label="姓名：" prop="username">
                        <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="电话：" prop="phone">
                        <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
        </el-row>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        return {
            youList: [
                {src:require('../../assets/images/plan-you4.png'),title:'增加学生进入名校机会',desc:'综合评价实施院校及区域不断壮大，不仅包括重点院校和中外合作院校，省属高校也有招生计划。'},
                {src:require('../../assets/images/plan-you2.png'),title:'高考双保险，提升录取成功率',desc:'如果考生在高考发挥失常，在高考裸分不占优势的情况下，有可能凭借综合成绩冲进目标院校。'},
                {src:require('../../assets/images/plan-you3.png'),title:'降分效果较好',desc:'大多数院校的录取分数线都是低于正常投档线，甚至有些院校降分幅度高达72分。'},
                {src:require('../../assets/images/plan-you1.png'),title:'招生条件比较宽泛',desc:'综合评价的招生条件一般要求综合成绩、综合素质、学科特长、社会实践等多个维度，考生满足某个或几个条件即可。即使没有奖项也可报考，不同层次考生均可尝试。'},
            ],
            tipsList: [
                {month:'3',desc:'了解政策、定位目标院校、提升背景、准备报考材料'},
                {month:'4',desc:'招生简章发布 进行报名、初审'},
                {month:'5',desc:'初审名单陆续公布'},
                {month:'6',desc:'参加高考，高考后参加校测、志愿填报'},
                {month:'7',desc:'院校录取'},
            ],
            stepList:[
                {count:'01',title:'考生信息收集'},
                {count:'02',title:'综合评价条件评估'},
                {count:'03',title:'综合评价申请初步方案'},
                {count:'04',title:'综合评价自荐信书写'},
                {count:'05',title:'综合评价申请最终方案设计'},
                {count:'06',title:'综合评价申请材料准备'},
                {count:'07',title:'综合评价申请指导'},
            ],
            serviceList: [
                {src:require('../../assets/images/plan-service-icon1.png'),title:'团队保障',desc:'荔枝新高考顶级专家团队全程跟踪,一对一线上线下规划指导。'},
                {src:require('../../assets/images/plan-service-icon2.png'),title:'结果保障',desc:'可帮助申请最多5所综评院校，并保证最少一所院校通过初审。'},
                {src:require('../../assets/images/plan-service-icon3.png'),title:'流程保障',desc:'综合评价申请一站式服务、院校选择、材料准备自荐信指导等。'},
            ],
            formInline: {
                username: '',
                phone: '',
                type: '7'
            },
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
            }
        };
    },

    mounted() {
        
    },

    methods: {
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
@font-face {
    font-family: 'Impact';
    src: url('../../assets/fonts/Impact.ttf');
}
@font-face {
    font-family: 'zihun443hao';
    src: url('../../assets/fonts/zihun443hao.ttf');
}
$width: 1200px;
$margin: 0 auto;
$font-family: 'MicrosoftYaHei';
.plan-box-bg {
    background: url('../../assets/images/plan-bg.jpg') no-repeat;
    background-size: cover;
    width: 100%;
    height: 1726px;
    .plan-box-ping {
        height: 338px;
        background: rgba(255,255,255,0.90);
        border-radius: 20px;
        box-shadow: 0px 8px 20px 0px rgba(0,123,71,0.29), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
        backdrop-filter: blur(6px);
        padding: 42px 48px;
        box-sizing: border-box;
        margin-top: 470px;
        h3 {
            color: #15B174;
            span {
                color: #332e2c;
            }
        }
        p {
            font-size: 22px;
            font-weight: 400;
            line-height: 44px;
            color: #2c3331;
            margin-top: 34px;
        }
    }
    .plan-box-you {
        margin-top: 74px;
        h3 {
            color: #ffffff;
        }
        .plan-box-you-title {
            color: rgba(255,255,255,0.23);
            top: 25px;
        }
        .plan-box-you-infor {
            width: 1120px;
            height: 668px;
            background: rgba(255,255,255,0.90);
            border-radius: 20px;
            box-shadow: 0px 8px 20px 0px rgba(0,123,71,0.29), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
            backdrop-filter: blur(6px);
            margin-top: 57px;
            position: relative;
            padding: 48px 230px 14px 40px;
            box-sizing: border-box;
            .el-col-22 {
                padding-left: 6px;
            }
        }
        .plan-box-you-img {
            position: absolute;
            right: -80px;
            bottom: -20px;
        }
        .plan-box-you-list {
            h4 {
                font-size: 26px;
                font-weight: 700;
                color: #2c3331;
                font-family: $font-family;
                margin: 0;
                padding: 0;
            }
            p {
                font-size: 20px;
                font-weight: 400;
                color: #5e6663;
                line-height: 36px;
                margin-top: 20px;
                margin-bottom: 36px;
            }
        }
    }
}
.plan-box-common {
    position: relative;
    width: $width;
    margin: $margin;
    .plan-box-you-title {
        position: absolute;
        font-size: 28px;
        font-family: $font-family;
        font-weight: 700;
        text-align: center;
        color: rgba(125,159,148,0.12);
        left: 50%;
        transform: translateX(-50%);
        top: 70px;
    }
    h3 {
        font-weight: 700;
        font-size: 38px;
        letter-spacing: 6px;
        margin: 0 auto;
        padding: 0;
        text-align: center;
        font-family: $font-family;
    }
}
.plan-box-common1 {
    padding-top: 64px;
    h3 {
        color: #15B174;
        line-height: 50px;
        span {
            color: #332e2c;
        }
    }
    .plan-box-you-title {
        top: 90px;
    }
}
.plan-box-liu {
    background: url('../../assets/images/plan-tips.jpg') no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 902px;
    p {
        font-weight: 400;
        font-size: 16px;
        color: #999390;
        text-align: center;
        margin-top: 55px;
        span {
            display: inline-block;
            width: 18px;
            height: 18px;
            background: #ffffff;
            border: 1px solid #ccc6c4;
            border-radius: 50%;
            margin-right: 2px;
        }
    }
    .plan-box-liu-item {
        background: linear-gradient(180deg,#ffa919, #ff8e10)!important;
        color: #fff!important;
    }
    .plan-box-liu-list {
        margin-top: 61px;
    }
    .plan-box-liu-common {
        width: 420px;
        height: 114px;
        background: rgba(255,255,255,0.86);
        border-radius: 20px;
        box-shadow: 0px 8px 20px 0px rgba(0,123,71,0.09); 
        color: #2c3331;
        font-weight: 400;
        font-size: 22px;
        margin-top: 6px;
        padding: 21px 32px;
        display: flex;
        align-items: center;
        line-height: 36px;
        margin-right: 10px;
    }
    .plan-box-liu-item1 {
        padding-left: 95px;
    }
    .plan-box-liu-item2 {
        padding-left: 58px;
    }
    .plan-box-liu-left {
        position: relative;
        .plan-box-liu-month,.plan-box-liu-common {
            float: right;
        }
    }
    .plan-box-liu-left-float {
        float: right;
        .plan-box-liu-month,.plan-box-liu-common {
            float: left;
        }
        .plan-box-liu-line1 {
            left: 0!important;
        }
        .plan-box-liu-circle1 {
            left: -33px!important;
        }
        .plan-box-liu-common {
            text-align: left;
            margin-left: 10px;
        }
    }
    .plan-box-liu-month {
        position: relative;
        top: 36px;
        width: 36px;
        height: 36px;
    }
    .plan-box-liu-line1 {
        width: 2px;
        height: 120px;
        border-left: 1px dashed #bed6cb;
        position: absolute;
        right: -4px;
    }
    .plan-box-liu-circle1 {
        width: 64px;
        height: 64px;
        background: linear-gradient(141deg,#5ee593 0%, #0cb16b 100%);
        border-radius: 50%;
        font-size: 20px;
        font-family: $font-family;
        color: #ffffff;
        font-weight: 400;
        text-align: center;
        line-height: 64px;
        position: relative;
        right: -5px;
        span {
            font-size: 40px;
        }
    }
}
.plan-box-nan {
    width: 100%;
    height: 768px;
    background: #f0f7f4;
    position: relative;
    img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 25px;
    }
    h4 {
        font-size: 28px;
        font-weight: 700;
        font-family: $font-family;
        color: #332e2c;
        text-align: center;
        margin-top: 55px;
        span {
            color: #FF9E00;
        }
    }
    .plan-box-nan-item {
        width: 296px;
        height: 114px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ffffff;
        border: 1px solid #18b971;
        border-radius: 20px;
        box-shadow: 0px 0px 20px 0px rgba(0,123,71,0.11); 
        backdrop-filter: blur(6px);
        color: #2c3331;
        font-size: 24px;
        font-weight: 400;
        margin: $margin;
        padding: 0 30px;
        text-align: center;
        line-height: 36px;
    }
    .plan-box-nan-list {
        // position: relative;
        // left: 50%;
        // transform: translateX(-50%);
        width: 820px;
        margin: $margin;
        margin-top: 210px;
        // display: flex;
        // justify-content: center;
    }
}
.plan-box-step {
    background: url('../../assets/images/plan-step.jpg') no-repeat;
    height: 560px;
    width: 100%;
    background-position: center;
    background-size: cover;
    position: relative;
    .plan-box-step-list {
        display: flex;
        justify-content: center;
        margin-top: 80px;
    }
    .plan-box-step-item {
        width: 175px;
        display: flex;
        > div {
            width: 154px;
            height: 162px;
            background: linear-gradient(141deg,#5ee593 0%, #0cb16b 100%);
            border-radius: 20px;
            box-shadow: 0px 4px 17px 0px rgba(38,148,128,0.21); 
            padding: 20px 0 0 0;
            position: relative;
            overflow: hidden;
            box-sizing: border-box;
            h5 {
                font-size: 20px;
                font-family: $font-family;
                color: #ffffff;
                font-weight: 700;
                text-align: center;
                margin: 0;
                padding: 0 16px;
                line-height: 32px;
            }
            .plan-box-step-circle {
                width: 110px;
                height: 110px;
                background: #ffbc2c;
                border-radius: 50%;
                font-size: 56px;
                font-family: 'Impact';
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 110px;
                position: absolute;
                right: -15px;
                bottom: -45px;
            }
        }
        img {
            width: 21px;
            height: 136px;
            position: relative;
            top: 80px;
        }
    }
    .plan-box-step-item-diff {
        >div {
            position: relative;
            top: 130px;
        }
    }
}
.plan-box-service {
    height: 902px;
    background: url('../../assets/images/plan-fu.jpg') no-repeat;
    background-size: cover;
    width: 100%;
    background-position: center;
    .plan-box-service-list {
        width: $width;
        margin: $margin;
        margin-top: 65px;
        .el-col {
            width: 351px;
            height: 426px;
            background: rgba(255,255,255,0.90);
            border-radius: 20px;
            box-shadow: 0px 8px 20px 0px rgba(0,123,71,0.29), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
            backdrop-filter: blur(6px);
            padding: 32px 43px;
            box-sizing: border-box;
            text-align: center;
            h4 {
                font-size: 30px;
                font-family: $font-family;
                font-weight: 700;
                text-align: center;
                color: #2c3331;
                line-height: 36px;
                margin: 33px 0 24px 0;
            }
            div {
                font-size: 22px;
                font-family: $font-family;
                font-weight: 400;
                color: #5e6663;
                line-height: 40px;
                text-align: left;
            }
        }
    }

}
.plan-box-order {
    @include gwidth;
    width: 1200px;
    height: 255px;
    background: linear-gradient(180deg,#ff9e4a, $common-color);
    border-radius: 20px;
    box-shadow: 0px 8px 30px 0px rgba(255,97,26,0.38);
    padding: 48px;
    margin-top: -170px;
    position: relative;
    margin-bottom: 28px;
    span {
        display: inline-block;
    }
    img {
        position: absolute;
        top:0;
        left: 0;
    }
    .plan-box-order-title {
        font-size: 36px;
        font-family: 'zihun443hao';
        color: #ffffff;
    }
    .plan-box-order-desc {
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        margin-left: 24px;
    }
}
</style>